import { Link } from 'react-router-dom'

import { Box, Divider, Icon, Text } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

export const EmptyState = ({ canManageCostCenters }: { canManageCostCenters: boolean }) => {
  const { navigation } = useNavigation()

  return (
    <Box gap="s8">
      <Box flexDirection="row" gap="s4" justifyContent="spaceBetween" alignItems="center">
        <Text.Normal size="300" color="grey1000" weight="semibold">
          {i18n.t('expenses_v2.forms.new_form.blocks.cost_center_information')}
        </Text.Normal>
        {canManageCostCenters && (
          <Link to={navigation.settings.finance.costCenters.fullPath()}>
            <Box flexDirection="row" gap="s4" alignItems="center">
              <Text.Normal size="200" color="grey1000" weight="semibold" underlined>
                {i18n.t('expenses_v2.forms.new_form.blocks.cost_center_information_settings')}
              </Text.Normal>
              <Icon.Small icon="external-link" color="grey1000" />
            </Box>
          </Link>
        )}
      </Box>
      <Text.Normal size="200" color="grey800">
        {i18n.t('expenses_v2.forms.new_form.blocks.cost_center_information_settings_subtitle')}
      </Text.Normal>
      <Box paddingTop="s16" paddingBottom="s16">
        <Divider vertical={false} />
      </Box>
    </Box>
  )
}
